import { buildTextdomain } from 'react-gettext';
import Localization from '@dealersites/core/translations/Localization';

const dsp = (global.dsp = global.dsp ?? {});

const i18n = (global.i18n = global.i18n || {});
const DS_INVENTORY_TEXT_DOMAIN = 'dealersite-inventory';
const pageLocale = document.documentElement.lang ?? 'en-CA';

const translations = {
  en: buildTextdomain(require('./en.json')),
  fr: buildTextdomain(require('./fr.json')),
};

const inventoryLocalization = new Localization(translations, DS_INVENTORY_TEXT_DOMAIN);
i18n.inventory = inventoryLocalization;

function makeFormatter(options) {
  const formatter = new Intl.NumberFormat(pageLocale, options);

  const format = (value, tags = ['default'], ...args) => {
    const preProcessor = dsp.dealerTools?.get(options.preProcessor) ?? ((price) => price);
    return formatter.format(preProcessor(value, options, tags), ...args);
  };

  const formatMethod = format.bind(this);
  formatMethod.to = (value, ...args) => format(value, ['default', 'slider'], ...args);
  formatMethod.custom = (tags) => {
    return (value, ...args) => format(value, tags, ...args);
  };

  // This is all a rough workaround for `.format()` not having an inverse.
  const parts = formatter.formatToParts(1234.5);
  const decimal = parts.find(({ type }) => type === 'decimal')?.value;
  const cleaner = decimal ? new RegExp(`[^\\-\\d\\${decimal}]`, 'g') : /[^\-\d]/g;

  formatMethod.from = (value) => {
    const cleaned = value.replace(cleaner, '').replace(decimal, '.');
    return Number.parseFloat(cleaned);
  };

  return formatMethod;
}

const formatPrice = makeFormatter({
  style: 'currency',
  currency: 'CAD',
  currencyDisplay: 'narrowSymbol',
  maximumFractionDigits: 0,
  preProcessor: 'inventory_preprocess_price',
});
const formatMileage = makeFormatter({
  style: 'unit',
  unit: 'kilometer',
  unitDisplay: 'narrow',
  maximumFractionDigits: 0,
  preProcessor: 'inventory_preprocess_mileage',
});

const formatter = (dsp.formatter = dsp.formatter ?? {});
formatter.mileage = formatMileage;
formatter.price = formatPrice;

export {
  inventoryLocalization,
  translations,
  formatPrice,
  formatMileage,
  makeFormatter,
  DS_INVENTORY_TEXT_DOMAIN,
};
